import { useQuery } from '@tanstack/react-query';
import {
  DashboardChartMeta,
  ListChartsResponse
} from '@blisspointmedia/bpm-types/dist/dashboarding';
import { awaitJSON, DashboardingLambdaFetch } from '../../../utils/fetch-utils';

// All of a company's saved charts (metadata only) — the chart library, independent of any dashboard.
// A chart appears here whether or not it's placed on a dashboard.
export const useChartLibrary = (company: string) =>
  useQuery<DashboardChartMeta[]>({
    queryKey: ['chart-library', company],
    enabled: Boolean(company),
    queryFn: async () => {
      const res = await DashboardingLambdaFetch('/listCharts', { params: { company } });
      return awaitJSON<ListChartsResponse>(res);
    }
  });
